import { Validator } from '../Validator';

export default class IBANService implements Validator {
  // tslint:disable-next-line 
  private ibanRegex: RegExp = /^[a-zA-Z]{2}[0-9]{2}\s?[a-zA-Z0-9]{4}\s?[0-9]{4}\s?[0-9]{3}([a-zA-Z0-9]\s?[a-zA-Z0-9]{0,4}\s?[a-zA-Z0-9]{0,4}\s?[a-zA-Z0-9]{0,4}\s?[a-zA-Z0-9]{0,3})?$/;
  // tslint:disable-next-line no-any
  public getValidation(iban: any, message: string = 'ibanFormat'): Promise<void> {
    return new Promise(
      (res, error) => {
        if (!iban) {
          res();
        }
        if (iban && typeof iban === 'string' && this.ibanRegex.test(iban)) {
          res();
        } else {
          error(message);
        }
      });
  } 
}



// WEBPACK FOOTER //
// ./src/services/validation/validators/IBAN.tsx